import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  padding-top: ${({ theme }) => theme.typography.pxToRem(80)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(160)};
`

export const Wrapper = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
    .swiper-wrapper {
      position: relative;
      left: -120px;
      //height: 600px;
    }
  }

  .swiper-wrapper {
    //margin-bottom: 4rem;
    //height: 750px;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    .swiper-slide {
      height: auto !important;
    }
  }
  .swiper-pagination {
    position: relative;
    margin-top: 2.5rem;
  }
  .swiper-pagination-bullet {
    background-color: transparent;
    border: 0.5px solid ${({ theme }) => theme.palette.primary.main};
  }
  .swiper-pagination-bullet-active {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export const ContentContainer = styled.div`
  border-radius: 24px;
  border: 1px solid #80d0bc;
  background: ${({ theme }) => theme.palette.secondary.light};
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  ${({ theme }) => theme.breakpoints.up("md")} {
    height: calc(100% - 66px);
  }
`
export const TopContainer = styled.div``

export const LogoContainer = styled.div`
  // border-radius: 100px;
  // background: ${({ theme }) => theme.palette.primary.light};
  // display: flex;
  // width: 80px;
  // height: 80px;
  // padding: 1rem;
  // justify-content: center;
  // align-items: center;
  // overflow: hidden;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(14)};
`

export const Logo = styled(CustomImage)`
  width: 80px;
  height: 80px;
  img {
    width: 80px;
    height: 80px;
    object-fit: contain !important;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(72)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(80)};
  letter-spacing: -1.44px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(72)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(36)};
    line-height: ${({ theme }) => theme.typography.pxToRem(48)};
  }
`

export const CardTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  margin-top: 1.75rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-top: 2.5rem;
  }
`
